<div class="tabs">
  <div (click)="changeTabAction('customer')" class="detail" [class.selectTab]="showCustomerGrid">
    <span> {{ "ClientApp.Pages.PageMenu.DeliveredCustomer" | translate }}</span>
  </div>
  <div (click)="changeTabAction('driver')" class="detail" [class.selectTab]="showDriverGrid">
    <span>{{ "ClientApp.Pages.PageMenu.DeliveredDriver" | translate }}</span>
  </div>
  <div (click)="changeTabAction('kitchen')" class="detail" [class.selectTab]="showKitchenGrid">
    <span>{{ "ClientApp.Pages.PageMenu.DeliveredKitchen" | translate }}</span>
  </div>
</div>

<div class="review show" [class.hide]="!showKitchenGrid">
  <div class="gridbox">
    <div class="d-flex dropDown-header-right">
      <div class="dropDown-ssg">
        <ssg-select
          class="dropDown-item"
          name="PrintPolicies"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.PrintPolicy.PrintSetting' | translate"
          textFieldName="Title"
          valueFieldName="Title"
          [multiple]="true"
          [dataList]="PrintPoliciesList"
          userClass="select-sm"
          (valueChange)="PrintSettingChange()">
        </ssg-select>
        <ssg-select
          class="dropDown-item"
          name="SaleMethodBranchIds"
          [group]="formGroup"
          class="SaleMethod"
          [label]="'ClientApp.FrontOffice.PrintPolicy.SaleMethods' | translate"
          textFieldName="Title"
          [dataList]="SaleMethodBranchList"
          valueFieldName="Id"
          [multiple]="true"
          (valueChange)="SaleMethodChange()"
          userClass="select-md">
        </ssg-select>
      </div>
      <div class="dropDown-header-left">
        <ssg-input
          (onEnter)="barCodeFinder($event, 'kitchen')"
          [label]="'ClientApp.FrontOffice.Order.Delivered.Barcode' | translate"
          name="barcodeInput{{ __id }}"
          [group]="formGroup"
          userClass="select-sm"
          required="false"
          textType="text"
          [disabled]="false">
        </ssg-input>
        <i (click)="loadInvoices(false)" id="refresh-btn" class="icon-spinner11"></i>
      </div>
    </div>
    <div class="content d-flex" *ngIf="DeliveredListInvoicePending?.length > 0">
      <div class="info" *ngFor="let invoice of DeliveredListInvoicePending">
        <div class="header">
          <div class="header-factor">
            <span>{{ "ClientApp.FrontOffice.Order.Delivered.Invoice" | translate }}: </span>
          </div>
          <div
            class="detail-factor"
            [ngClass]="{
              green: !invoice.HasExpired,
              red: invoice.HasExpired
            }">
            <span>{{ invoice.NumberingInDate }} - </span>
            <span>{{ invoice.SaleMethodBranchTitle }}</span>
          </div>
        </div>
        <div class="box-info">
          <table>
            <tr>
              <th class="text-right">{{ "ClientApp.FrontOffice.Order.Delivered.ProductName" | translate }}</th>
              <th class="text-center">{{ "ClientApp.FrontOffice.Order.Delivered.Number" | translate }}</th>
              <th class="text-center">{{ "ClientApp.FrontOffice.Order.Delivered.Delivery" | translate }}</th>
            </tr>
            <tr *ngFor="let item of invoice.Items" [ngClass]="{ gray: item.Checked }">
              <td class="text-right">{{ item.ItemTitle }}</td>
              <td class="text-center">{{ item.Quantity }}</td>
              <td class="d-flex justify-content-center">
                <ssg-checkbox
                  class="qty"
                  name="ItemChecked{{ item.ItemId }} {{ invoice.Id }}"
                  [group]="group"
                  (valueChange)="item.Checked = !item.Checked; itemOnChange(invoice)"></ssg-checkbox>
              </td>
            </tr>
          </table>
        </div>
        <div class="footer">
          <div class="invoice-description">
            {{ "ClientApp.FrontOffice.Order.Delivered.Description" | translate }}:
            {{ invoice.Description }}
          </div>
          <div class="d-flex justify-content-center footer-info">
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.Delivery">{{ invoice.CustomerDisplayName }} -</div>
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.Restaurant">{{ invoice.SalonTitle }} -</div>
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.FastFood"></div>
            <div>
              <div>{{ invoice.FactorStringTime | formatTimeFromBackend }}</div>
            </div>
          </div>
        </div>
        <div class="recieve-btn">
          <ssg-button
            (click)="deliveredInvoice(invoice, false, true)"
            [label]="'ClientApp.FrontOffice.Order.Delivered.Delivered' | translate"></ssg-button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="review show" *ngIf="showDriverGrid">
  <div class="gridbox">
    <div class="d-flex dropDown-header-right">
      <div class="dropDown-header-left mt-2">
        <ssg-input
          (onEnter)="barCodeFinder($event, 'driver')"
          [label]="'ClientApp.FrontOffice.Order.Delivered.Barcode' | translate"
          name="barcodeInput{{ __id }}"
          [group]="formGroup"
          userClass="select-sm"
          required="false"
          textType="text"
          [disabled]="false"></ssg-input>
        <i (click)="loadInvoices(false)" id="refresh-btn" class="icon-spinner11"></i>
      </div>
    </div>
    <div class="content d-flex" class="content d-flex" *ngIf="DeliveredListInvoiceDriver?.length > 0">
      <div class="info" *ngFor="let invoice of DeliveredListInvoiceDriver">
        <div class="header">
          <div class="header-factor">
            <span>{{ "ClientApp.FrontOffice.Order.Delivered.Invoice" | translate }} </span>
          </div>
          <div
            class="detail-factor"
            [ngClass]="{
              green: !invoice.HasExpired,
              red: invoice.HasExpired
            }">
            <span>{{ invoice.NumberingInDate }} - </span>
            <span>{{ invoice.SaleMethodBranchTitle }}</span>
          </div>
        </div>
        <div class="box-info">
          <table>
            <tr>
              <th class="text-right">{{ "ClientApp.FrontOffice.Order.Delivered.ProductName" | translate }}</th>
              <th class="text-center">{{ "ClientApp.FrontOffice.Order.Delivered.Number" | translate }}</th>
            </tr>
            <tr *ngFor="let item of invoice.Items">
              <td class="text-right">{{ item.ItemTitle }}</td>
              <td class="text-center">{{ item.Quantity }}</td>
            </tr>
          </table>
        </div>
        <div class="footer">
          <div class="invoice-description">
            {{ "ClientApp.FrontOffice.Order.Delivered.Description" | translate }}:
            {{ invoice.Description }}
          </div>
          <div class="d-flex justify-content-center footer-info">
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.Delivery">{{ invoice.CustomerDisplayName }} -</div>
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.Restaurant">{{ invoice.SalonTitle }} -</div>
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.FastFood"></div>
            <div>
              <div>{{ invoice.FactorStringTime | formatTimeFromBackend }}</div>
            </div>
          </div>
        </div>
        <div class="recieve-btn">
          <ssg-button
            (click)="deliveredInvoice(invoice, false, true)"
            [label]="'ClientApp.FrontOffice.Order.Delivered.Delivered' | translate"></ssg-button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="review show" *ngIf="showCustomerGrid">
  <div class="gridbox">
    <div class="d-flex dropDown-header-right">
      <div class="dropDown-header-left">
        <i (click)="loadInvoices(false)" id="refresh-btn" class="icon-spinner11"></i>
      </div>
    </div>
    <div class="content d-flex" class="content d-flex" *ngIf="DeliveredListInvoiceKitchen?.length > 0">
      <div class="info" *ngFor="let invoice of DeliveredListInvoiceKitchen">
        <div class="header">
          <div class="header-factor">
            <span>{{ "ClientApp.FrontOffice.Order.Delivered.Invoice" | translate }} </span>
          </div>
          <div
            class="detail-factor"
            [ngClass]="{
              green: !invoice.HasExpired,
              red: invoice.HasExpired
            }">
            <span>{{ invoice.NumberingInDate }} - </span>
            <span>{{ invoice.SaleMethodBranchTitle }}</span>
          </div>
        </div>
        <div class="box-info">
          <table>
            <tr>
              <th class="text-right">{{ "ClientApp.FrontOffice.Order.Delivered.ProductName" | translate }}</th>
              <th class="text-center">{{ "ClientApp.FrontOffice.Order.Delivered.Number" | translate }}</th>
            </tr>
            <tr *ngFor="let item of invoice.Items">
              <td class="text-right">{{ item.ItemTitle }}</td>
              <td class="text-center">{{ item.Quantity }}</td>
            </tr>
          </table>
        </div>
        <div class="footer">
          <div class="invoice-description">
            {{ "ClientApp.FrontOffice.Order.Delivered.Description" | translate }}:
            {{ invoice.Description }}
          </div>
          <div class="d-flex justify-content-center footer-info">
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.Delivery">{{ invoice.CustomerDisplayName }} -</div>
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.Restaurant">{{ invoice.SalonTitle }} -</div>
            <div *ngIf="invoice.SaleMethodNatureCode === SaleMethodNatureEnum.FastFood"></div>
            <div>
              <div>{{ invoice.FactorStringTime | formatTimeFromBackend }}</div>
            </div>
          </div>
        </div>
        <div class="recieve-btn">
          <ssg-button
            (click)="deliveredInvoice(invoice, false, true)"
            [label]="'ClientApp.FrontOffice.Order.Delivered.Delivered' | translate"></ssg-button>
        </div>
      </div>
    </div>
  </div>
</div>
